import Vue from 'vue'

const MessageConstructor = Vue.extend(require('./index.vue').default)

let messageInstance = null

const getInstance = () => {
  if (!messageInstance) {
    messageInstance = new MessageConstructor({ el: document.createElement('div') })
  }
  return messageInstance
}

const Message = (function () {
  return {
    show (options) {
      const message = typeof options === 'object' ? options.message : options
      if (!messageInstance) {
        getInstance()
        document.body.appendChild(messageInstance.$el)
      }
      messageInstance.message = message || ''
      messageInstance.visible = true
    },

    hide () {
      if (messageInstance) messageInstance.visible = false
    }
  }
}())

export default Message
